module.exports = __webpack_public_path__ + "img/automato-robotics.c5394ad3.png";